import React from 'react';
import '../styles/MoneyAnimation.css';

const MoneyAnimation: React.FC = () => {
  return (
    <div className="money-animation">
      <div className="vault">
        <div className="vault-body"></div>
        <div className="vault-door"></div>
        <div className="vault-lock"></div>
      </div>
      <div className="money-bills">
        <div className="bill bill-1"></div>
        <div className="bill bill-2"></div>
        <div className="bill bill-3"></div>
        <div className="bill bill-4"></div>
      </div>
    </div>
  );
};

export default MoneyAnimation;
